import { Button } from '../Button/Button.tsx';
import { Dialog } from '../Dialog/Dialog.tsx';

export type ConfirmDialogProps = {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  closeLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export const ConfirmDialog = ({
  title,
  message,
  confirmLabel,
  cancelLabel,
  closeLabel,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => (
  <Dialog
    open
    title={title}
    closeLabel={closeLabel}
    onClose={onCancel}
    footer={
      <>
        <Button variant="outline" onClick={onCancel}>
          {cancelLabel}
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </>
    }
  >
    <p>{message}</p>
  </Dialog>
);
